webpackJsonp([35783957827783],{

/***/ 421:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(80);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var resources = [{
	  title: 'FAQ',
	  icon: 'fa-question-circle',
	  href: '/faq',
	  description: 'Start with short answers about state machines, statecharts, SCXML, and this site.'
	}, {
	  title: 'Tutorial',
	  icon: 'fa-book',
	  href: '/tutorials/fundamentals',
	  description: 'Work through the SCXML tutorial and learn the core statechart concepts.'
	}, {
	  title: 'Examples',
	  icon: 'fa-code',
	  href: '/examples',
	  description: 'Browse runnable examples powered by SCION. More SCXML examples will be added over time.'
	}, {
	  title: 'Tooling',
	  icon: 'fa-wrench',
	  href: '/tooling',
	  description: 'Find editors, visualization tools, and SCION Studio information.'
	}];
	
	var ResourceLink = function ResourceLink(_ref) {
	  var resource = _ref.resource;
	  return _react2.default.createElement(
	    'div',
	    { className: 'col-md-3', style: { marginBottom: '2rem' } },
	    _react2.default.createElement(
	      _gatsbyLink2.default,
	      { to: resource.href, style: { color: 'inherit', textDecoration: 'none' } },
	      _react2.default.createElement(
	        'div',
	        { style: { textAlign: 'center' } },
	        _react2.default.createElement('i', { className: 'fas ' + resource.icon + ' fa-4x', 'aria-hidden': 'true' }),
	        _react2.default.createElement(
	          'h3',
	          { style: { marginTop: '1rem' } },
	          resource.title
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          resource.description
	        )
	      )
	    )
	  );
	};
	
	var Home = function Home() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'container' },
	    _react2.default.createElement(
	      'div',
	      { className: 'jumbotron' },
	      _react2.default.createElement(
	        'div',
	        { className: 'container' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          'SCXML.IO'
	        ),
	        _react2.default.createElement(
	          'p',
	          { className: 'lead' },
	          'An open source informational site about the W3C SCXML standard for hierarchical state machines and statecharts.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'This site is not affiliated with W3C. It is powered by',
	          ' ',
	          _react2.default.createElement(
	            'a',
	            { href: 'https://github.com/jbeard4/SCION' },
	            'SCION'
	          ),
	          '.'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        resources.map(function (resource) {
	          return _react2.default.createElement(ResourceLink, { key: resource.title, resource: resource });
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'row' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col-md-8 offset-md-2' },
	          _react2.default.createElement(
	            'h2',
	            null,
	            'What is SCXML?'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'SCXML is an XML-based language for describing statecharts: state machines with hierarchy, concurrency, events, and executable actions. It is useful for modeling application behavior, workflows, interaction logic, and other systems whose behavior changes in response to events.'
	          ),
	          _react2.default.createElement(
	            'p',
	            null,
	            'This site collects practical resources for learning SCXML and using it with SCION. Later, we will add more SCXML examples. One day, we will release SCION Studio as well.'
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Home;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-02c97944a0853b3bca31.js